
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
import { namespace } from "vuex-class";
import { template } from "lodash";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
// interfaces
import { courseElementTypeItems } from "@/interfaces/Types";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { CustomizationVm } from "@/interfaces/CustomizationVm";
import { ExBundleVM } from "@/interfaces/ExBundleAssignmentGroupVM";

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
    ExpandableCard,
  },
})
export default class FlipCardListElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;

  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedBundle!: ExBundleVM;
  // @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedElement!: CourseElementVm | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;

  mounted() {
    if (!this.selectedBundle.sequentialModuleProcessing) {
      this.selectedElement!.preventSeeking = false;
    }
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
